import React from "react";

const sizes = {
  textxs: "text-[10px] font-normal",
  texts: "text-[12px] font-normal",
  textmd: "text-[13px] font-normal",
  textlg: "text-[14px] font-normal",
  textxl: "text-[15px] font-normal",
  text2xl: "text-[16px] font-normal lg:text-[13px]",
  text3xl: "text-[18px] font-normal lg:text-[15px]",
  text4xl: "text-[22px] font-normal lg:text-[18px]",
};

const Text = ({ children, className = "", as, size = "texts", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-gray-700 font-actor ${className} ${sizes[size]} `} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
